import OneSignal from './onesignal';

export default OneSignal;
